/* Delegates to Dawn's existing form: never maintains a second variant/cart state. */
if (!customElements.get('onewatch-sticky-cart')) {
  customElements.define('onewatch-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.ow-sticky');
      this.spacer = this.querySelector('.ow-sticky-spacer');
      this.add = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      if (!this.bar) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.sync();
        });
      };
      this.add.addEventListener('click', () => {
        this.sync();
        if (!this.add.disabled && this.submit) {
          // Click the original submitter so Dawn and app validation stay intact.
          this.submit.click();
          this.schedule();
        }
      }, options);
      this.querySelector('[data-options]').addEventListener('click', (event) => {
        if (!this.main) return;
        event.preventDefault();
        const target = this.main.querySelector('variant-selects input, variant-selects select, variant-radios input') || this.submit;
        if (!target) return;
        this.main.scrollIntoView({ behavior: 'auto', block: 'start' });
        target.focus({ preventScroll: true });
      }, options);
      window.addEventListener('scroll', this.schedule, { ...options, passive: true });
      window.addEventListener('resize', this.schedule, options);
      document.addEventListener('shopify:section:load', this.schedule, options);
      document.addEventListener('shopify:section:unload', this.schedule, options);
      document.addEventListener('product-info:loaded', this.schedule, options);
      this.resize = new ResizeObserver(() => {
        if (!this.bar.hidden) this.spacer.style.setProperty('--ow-bar-height', `${this.bar.offsetHeight}px`);
      });
      this.resize.observe(this.bar);
      this.sync();
    }

    sync() {
      const main = document.querySelector('[id^="MainProduct-"]');
      if (main !== this.main) {
        this.observer?.disconnect();
        this.main = main;
        if (main) {
          this.observer = new MutationObserver(this.schedule);
          this.observer.observe(main, { subtree: true, childList: true, attributes: true, characterData: true });
        }
      }
      this.submit = main?.querySelector('product-form form[action*="/cart/add"] [name="add"]');
      if (!this.submit || this.submit.getClientRects().length === 0) {
        this.bar.hidden = this.spacer.hidden = true;
        return;
      }
      const form = this.submit.form;
      const variant = form?.querySelector('[name="id"]');
      const busy = this.submit.getAttribute('aria-disabled') === 'true' || this.submit.classList.contains('loading');
      this.add.disabled = this.submit.disabled || busy || !variant?.value || variant.disabled;
      this.add.setAttribute('aria-busy', String(busy));
      const label = this.submit.querySelector('span:not(.loading__spinner)')?.textContent.trim() || this.submit.textContent.trim();
      if (this.add.textContent !== label) this.add.textContent = label;
      const errorNode = this.submit.closest('product-form')?.querySelector('.product-form__error-message');
      const errorWrapper = errorNode?.closest('.product-form__error-message-wrapper');
      const error = errorNode && !errorWrapper?.hidden ? errorNode.textContent.trim() : '';
      if (this.status.textContent !== error) this.status.textContent = error;
      // Match a swapped combined-listing product title as well.
      const title = main.querySelector('.product__title h1, h1')?.textContent.trim();
      if (title) this.querySelector('.ow-sticky-title').textContent = title;
      const show = this.submit.getBoundingClientRect().bottom < 0;
      // Preserve focus if scrolling while interacting with the bar.
      const visible = show || this.bar.contains(document.activeElement);
      this.bar.hidden = this.spacer.hidden = !visible;
      if (visible) this.spacer.style.setProperty('--ow-bar-height', `${this.bar.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
